import React from "react";
import { Grid, CircularProgress } from "@mui/material";
import DialogForm from "@/components/modal/DialogForm";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { StyledButton } from "@/components";
import FormikFileUpload from "@/components/forms/FormikFileUpload";
import { useMusterImportMutation } from "@/api/services/attendanceManagement/muster/Muster";
import { toast } from "@/components/toastify";

const Import = ({ open, setOpen }) => {

  const [musterImport] = useMusterImportMutation();
  const validationSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("File is required")
      .test("fileFormat", "Only Excel files are allowed", (value) => {
        if (!value) return false; // No file uploaded
        return value && ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"].includes(value.type);
      }),
  });

  const handleSubmit = async (values, { resetForm }) => {
    if (!values.file) {
      return;
    }

    const formData = new FormData();
    formData.append("file", values?.file);

    try {
      const response = await musterImport({ formData }).unwrap();

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "file.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast("success", "Uploaded Successfully!");

      resetForm();
      setOpen(false);
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  return (
    <DialogForm setOpen={setOpen} width={"sm"} height="auto" title={"Import"} open={open}>
      <Formik
        initialValues={{
          // SelectEmployee: "",
          file: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => handleSubmit(values, actions)}
      >
        {({ isSubmitting, setFieldValue, resetForm }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormikFileUpload
                  placeholder="Choose File"
                  name="file"
                  label="Upload"
                  required
                  rows={1.5}
                  // handleChange={customHandleFileChange}
                  handleChange={(event, file) =>
                    setFieldValue("file", file)
                  }
                />

              </Grid>
            </Grid>

            <Grid container justifyContent="flex-end" spacing={2} mt={1}>
              <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <StyledButton
                  label={"Cancel"}
                  type="button"
                  variant="outlined"
                  onClick={() => { setOpen(false); resetForm(); }}
                  sx={{ mr: 1 }}
                />
                <StyledButton
                  label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                  type="submit"
                  variant="contained"
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </DialogForm>
  );
};

export default Import;
